export default Object.freeze({
  DefaultInitial: 0,
  CompleteInformation: 1,
  Approval: 2,
  AutoApprove: 3,
  Conditional: 4,
  ExecuteTask: 5,
  ExecuteApiCall: 6,
  AutoReject: 7,
  DigitalSignature: 8,
  SendEmail: 9,
  ExecuteQuery: 10,
  DynamicEntityOperation: 11,
  GenerateExcel: 12,
  StartProcessInstance: 13,
  SetVariableData: 14,
  SetFormData: 15,
  Parallel: 16,
  GenerateDocuments: 17,
  ScheduledExecution: 18,
  SharePointOperation: 19,
  Iterate: 20,
  Switch: 21,
  InternalOperation: 22,
  GeneratePlainTextFile: 23,
  ImportPlainTextFile: 24,
  ConsumeSequence: 25,
  ExecuteRpaFlow: 26,
  Integration: 27,
  AutoCancel: 28,
  AutoVoid: 29,
  OpenAI: 30,
  ExecuteProcessAction: 31,
  GoogleIntegration: 32,
  RevertCancellation: 33,
  RevertVoiding: 34,
  FTPOperation: 35,
  RunCode: 36,
  AutomyAI: 37,
  WhatsAppBusinessIntegration: 38,
});
